(function(){
  const DATA = JSON.parse(document.getElementById('pack-widget-data').textContent);
  DATA.products = DATA.products.filter((p, i, arr) => arr.findIndex(x => String(x.id) === String(p.id)) === i);

  const LOW_STOCK_THRESHOLD = 3;

  function money(cents){
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: DATA.currency });
  }

  function findProduct(id){
    return DATA.products.find(p => String(p.id) === String(id));
  }
  function firstAvailableVariant(p){
    if(!p || !p.variants || !p.variants.length) return null;
    return p.variants.find(v => v.available) || p.variants[0] || null;
  }
  function findVariantBySize(p, size){
    if(!p || !p.variants || !p.variants.length) return null;
    return p.variants.find(v => v.size === size && v.available)
        || p.variants.find(v => v.size === size)
        || firstAvailableVariant(p);
  }

  function getUrlVariantId(){
    return new URLSearchParams(window.location.search).get('variant');
  }

  let liveVariantId = getUrlVariantId() || DATA.currentVariantId;

  function getCurrentVariant(){
    const activeSizeBtn = document.querySelector('.ss-size--active');
    if(activeSizeBtn && activeSizeBtn.dataset.id && currentProduct){
      const v = currentProduct.variants.find(v => String(v.id) === String(activeSizeBtn.dataset.id));
      if(v) return v;
    }
    if(currentProduct){
      const v = currentProduct.variants.find(v => String(v.id) === String(liveVariantId));
      if(v) return v;
    }
    return firstAvailableVariant(currentProduct);
  }

  let activeTierId = 2; // 2-Pack pre-selected by default

  if(!DATA.products || !DATA.products.length){
    console.error('Pack widget: no product data found. Check the Linked Colors metafield and try again.');
  }

  const currentProduct = findProduct(DATA.currentProductId) || DATA.products[0];

  let tee1ProductId = currentProduct.id;
  let tee1Size = getCurrentVariant() ? getCurrentVariant().size : null;

  const otherProduct = DATA.products.find(p => String(p.id) !== String(currentProduct.id));
  let tee2ProductId = otherProduct ? otherProduct.id : currentProduct.id;
  const tee2DefaultVariant = firstAvailableVariant(findProduct(tee2ProductId));
  let tee2Size = tee2DefaultVariant ? tee2DefaultVariant.size : tee1Size;

  function getTeeVariant(productId, size){
    const p = findProduct(productId) || currentProduct;
    return { product: p, variant: findVariantBySize(p, size) || firstAvailableVariant(p) };
  }

  const CHECK_ICON = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>`;

  function sizeOptionLabel(variant){
    if(!variant.available){
      return `${variant.size} — Sold out`;
    }
    if(typeof variant.quantity === 'number' && variant.quantity > 0 && variant.quantity < LOW_STOCK_THRESHOLD){
      return `${variant.size} — ${variant.quantity} left`;
    }
    return variant.size;
  }

  function renderTeePicker(num, selectedProductId, selectedSize, onColorChange, onSizeChange){
    const p = findProduct(selectedProductId) || currentProduct;
    const v = findVariantBySize(p, selectedSize) || firstAvailableVariant(p);
    if(!v){
      return { html: `<div class="pw-tee"><span class="pw-tee-num">#${num}</span><span>Unavailable</span></div>`, bind: () => {} };
    }
    const colorOptionsHtml = DATA.products.map(prod => {
      const selected = String(prod.id) === String(selectedProductId) ? 'selected' : '';
      return `<option value="${prod.id}" ${selected}>${prod.color}</option>`;
    }).join('');
    const sizeOptionsHtml = p.variants.map(variant => {
      const selected = variant.size === v.size ? 'selected' : '';
      const disabled = !variant.available ? 'disabled' : '';
      return `<option value="${variant.size}" ${selected} ${disabled}>${sizeOptionLabel(variant)}</option>`;
    }).join('');

    return {
      html: `
        <div class="pw-tee">
          <span class="pw-tee-num">#${num}</span>
          <div class="pw-select-wrap">
            <span class="pw-select-label">Color</span>
            <select class="pw-select pw-select-color" aria-label="Tee ${num} color">${colorOptionsHtml}</select>
          </div>
          <div class="pw-select-wrap">
            <span class="pw-select-label">Size</span>
            <select class="pw-select pw-select-size" aria-label="Tee ${num} size">${sizeOptionsHtml}</select>
          </div>
        </div>`,
      bind: (el) => {
        el.querySelector('.pw-select-color').addEventListener('change', (e) => onColorChange(e.target.value));
        el.querySelector('.pw-select-size').addEventListener('change', (e) => onSizeChange(e.target.value));
      }
    };
  }

  function renderTiers(){
    const el = document.getElementById('pwTiers');
    el.classList.add('pw-tiers');

    const singlePriceCents = DATA.singlePriceCents;
    const packPriceCents = DATA.packPriceCents;
    const packPerTeeCents = Math.round(packPriceCents / 2);

    el.innerHTML = `
      <div class="pw-tier ${activeTierId === 1 ? 'active' : ''}" data-id="1">
        <div class="pw-tier-head">
          <span class="pw-radio"></span>
          <div class="pw-tier-label-row">
            <span class="pw-tier-label">Single</span>
          </div>
          <div class="pw-tier-price-block">
            <div class="pw-tier-price">${money(singlePriceCents)}</div>
          </div>
        </div>
        <div class="pw-tier-body">
          <div class="pw-tier-body-inner">
          </div>
        </div>
      </div>

      <div class="pw-tier ${activeTierId === 2 ? 'active' : ''}" data-id="2">
        <div class="pw-tier-head">
          <span class="pw-radio"></span>
          <div class="pw-tier-label-row">
            <span class="pw-tier-label">2-Pack</span>
            <span class="pw-tier-badge">Best value</span>
          </div>
          <div class="pw-tier-price-block">
            <div class="pw-tier-price">${money(packPriceCents)}</div>
            <div class="pw-tier-each">${money(packPerTeeCents)} each</div>
          </div>
        </div>
        <div class="pw-tier-body">
          <div class="pw-tier-body-inner">
            <div class="pw-tees" id="pwTees"></div>
          </div>
        </div>
      </div>
    `;

    el.querySelectorAll('.pw-tier').forEach(card => {
      card.addEventListener('click', (e) => {
        if(e.target.closest('.pw-tee')) return;
        activeTierId = Number(card.dataset.id);
        renderTiers();
      });
    });

    if(activeTierId === 2){
      const teesEl = document.getElementById('pwTees');
      const tee1 = renderTeePicker(1, tee1ProductId, tee1Size,
        (productId) => {
          tee1ProductId = productId;
          const v = firstAvailableVariant(findProduct(productId));
          tee1Size = v ? v.size : tee1Size;
          renderTiers();
        },
        (size) => { tee1Size = size; renderTiers(); }
      );
      const tee2 = renderTeePicker(2, tee2ProductId, tee2Size,
        (productId) => {
          tee2ProductId = productId;
          const v = firstAvailableVariant(findProduct(productId));
          tee2Size = v ? v.size : tee2Size;
          renderTiers();
        },
        (size) => { tee2Size = size; renderTiers(); }
      );
      teesEl.innerHTML = tee1.html + tee2.html;
      const teeEls = teesEl.querySelectorAll('.pw-tee');
      tee1.bind(teeEls[0]);
      tee2.bind(teeEls[1]);
    }
  }

  renderTiers();

  document.addEventListener('terragrown:variant-changed', (e) => {
    if(e.detail && e.detail.variantId){
      liveVariantId = e.detail.variantId;
    }
    renderTiers();
  });

  document.getElementById('pwAddBtn').addEventListener('click', function(){
    const btn = this;
    const errorEl = document.getElementById('pwError');
    errorEl.style.display = 'none';

    let items;
    if(activeTierId === 1){
      items = [{ id: getCurrentVariant().id, quantity: 1 }];
    } else {
      const t1 = getTeeVariant(tee1ProductId, tee1Size);
      const t2 = getTeeVariant(tee2ProductId, tee2Size);
      if(!t1.variant.available || !t2.variant.available){
        errorEl.textContent = 'One of the selected sizes is sold out — please pick a different size.';
        errorEl.style.display = 'block';
        return;
      }
      items = [
        { id: t1.variant.id, quantity: 1 },
        { id: t2.variant.id, quantity: 1 }
      ];
    }

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items,
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname
      })
    })
      .then(async res => {
        const body = await res.json().catch(() => null);
        if(!res.ok){
          const msg = (body && (body.description || body.message)) || 'Unknown error from Shopify.';
          console.error('Pack widget: cart/add failed', res.status, body, items);
          throw new Error(msg);
        }
        return body;
      })
      .then((body) => {

        if(body.sections && body.sections['cart-drawer-section']){
          const parser = new DOMParser();
          const doc = parser.parseFromString(body.sections['cart-drawer-section'], 'text/html');
          const newSection = doc.getElementById('shopify-section-cart-drawer-section');
          const oldSection = document.getElementById('shopify-section-cart-drawer-section');
          if(newSection && oldSection){

            oldSection.replaceWith(newSection);
          }
        }
        btn.disabled = false;
        btn.textContent = original;
        document.getElementById('pwNativeCartTrigger').click();
      })
      .catch((err) => {
        errorEl.textContent = err.message || 'Something went wrong adding that to your cart — please try again.';
        errorEl.style.display = 'block';
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();